/**
 * This method is common between internet filter tab and the groups tab.
 * Mixin to avoid duplicate code at both the places.
 */
export default {

    methods: {

        hideMobileListingForMobileIfListingItemSelected () {

            let self = this
            return (self.$vuetify.breakpoint.mdAndUp || (self.$vuetify.breakpoint.smAndDown && ! self.currentSelectedRuleKey))

        },
        hideMobileListingForMobileIfListingItemSelectedForGroups () {

            let self = this
            return (self.$vuetify.breakpoint.mdAndUp || (self.$vuetify.breakpoint.smAndDown && ! self.currentSelectedGroup))

        },
        hideMobileListingForMobileIfListingItemSelectedForConfigurations () {

            let self = this
            return (self.$vuetify.breakpoint.mdAndUp || (self.$vuetify.breakpoint.smAndDown && ! self.currentSelectedConfiguration))

        },

        setHeightForListingBox () {

            let self = this

            if (self.$vuetify.breakpoint.smAndUp) {
                // let consolidatedTopHeight = 244 // container has margin top 40 and 24 px padding, another 180 for some room.
                // let consolidatedTopHeight = 110 // container has margin top 40 and 24 px padding, another 180 for some room.
                let consolidatedTopHeight = 110 // container has margin top 40 and 24 px padding, another 180 for some room.

                const handles = ['header', '.v-tabs', '.search-listing-autocomplete']

                for (let i = 0; i < handles.length; i++) {
                    const handle = handles[i]
                    const handleHeight = jQuery(handle).outerHeight()
                    consolidatedTopHeight += handleHeight
                }

                jQuery(document).ready(function () {
                    jQuery('.v-list-wrapper').height('calc(100vh - ' + consolidatedTopHeight + 'px)')
                })

            }

        }
    }

}
